import React from 'react';
import { FaTwitter, FaGithub, FaTelegramPlane, FaEnvelope } from 'react-icons/fa';

const Footer = () => (
  <footer className="bg-gray-900 border-t border-gray-800 py-4 rounded-tl-lg rounded-tr-lg">
    <div className="px-4">
      <div className="flex flex-wrap justify-between">
        {/* Left Side: Company Info */}
        <div className="w-full md:w-1/3 mb-6 md:mb-0">
          <h2 className="text-xl font-bold mb-2">BlackNodes</h2>
          <p className="text-sm text-gray-400">
            BlackNodes, an Enterprise-Level Validator and staking platform based out of INDIA, provides reliable nodes and diverse geolocations for a truly decentralized network.
          </p>
        </div>

        {/* Center: Quick Links */}
        <div className="w-full md:w-1/3 mb-6 md:mb-0">
          <h2 className="text-xl font-bold mb-2">Quick Links</h2>
          <ul className="text-sm text-gray-400 space-y-2">
            <li>
              <a
                href="https://www.blacknodes.net/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-cyan-400 transition-colors duration-200"
              >
                Website
              </a>
            </li>
            <li>
              <a
                href="https://services.blacknodes.net/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-cyan-400 transition-colors duration-200"
              >
                Services
              </a>
            </li>
            <li>
              <a
                href="/contact"
                className="hover:text-cyan-400 transition-colors duration-200"
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        {/* Right Side: Connect with Us */}
        <div className="w-full md:w-1/3">
          <h2 className="text-xl font-bold mb-2">Connect with Us</h2>
          <div className="flex space-x-6 mt-2">
            <a
              href="https://twitter.com/blacknodes"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-cyan-400 transition-colors duration-200"
            >
              <FaTwitter size={24} />
            </a>
            <a
              href="https://github.com/blacknodes"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-cyan-400 transition-colors duration-200"
            >
              <FaGithub size={24} />
            </a>
            <a
              href="https://t.me/blacknodes"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-cyan-400 transition-colors duration-200"
            >
              <FaTelegramPlane size={24} />
            </a>
            <a
              href="mailto:contact@blacknodes.net"
              className="text-gray-400 hover:text-cyan-400 transition-colors duration-200"
            >
              <FaEnvelope size={24} />
            </a>
          </div>
          {/* Contact Information */}
          <div className="mt-4 text-sm text-gray-400">
            <p>Email: contact@blacknodes.net</p>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="mt-8 border-t border-gray-800 pt-4 text-center text-sm text-gray-400">
        <p>© {new Date().getFullYear()} BlackNodes. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
